import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'default' | 'success' | 'warning' | 'danger' | 'accent';

const toneClasses: Record<Tone, string> = {
  default: 'bg-border/40 text-text-secondary',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/15 text-warning',
  danger: 'bg-danger/10 text-danger',
  accent: 'bg-accent/10 text-accent',
};

export function Badge({
  tone = 'default',
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-1 rounded-full px-2.5 text-label uppercase tracking-[0.08em]',
        toneClasses[tone],
        className,
      )}
      {...props}
    />
  );
}
